var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { classes } from '../../helpers';
import { flexPosition, rowStyle } from './style';
export const Row = (props) => {
    const { className, onClick, style, children, gutter: __gutter, justifyContent: __justifyContent, alignItems: __alignItems, wrap: __wrap, flexDirection: __flexDirection } = props, rest = __rest(props, ["className", "onClick", "style", "children", "gutter", "justifyContent", "alignItems", "wrap", "flexDirection"]);
    return (React.createElement("div", Object.assign({ onClick: onClick, className: classes(rowStyle, flexPosition(props), className, 'sha-el-row'), style: style }, rest), children));
};
Row.defaultProps = {
    justifyContent: 'flex-start',
    gutter: ['10px 0', '.5rem'],
    wrap: 'wrap',
    flexDirection: 'row',
};
//# sourceMappingURL=Row.js.map